import React from 'react';
import type { FieldRole } from '../../types/config';
import type { FieldScreen } from '../../types/navigation';
import { useStore } from '../../contexts/StoreContext';
import { MobileHeader } from '../../components/mobile/MobileHeader';
import { ProcessTracker } from '../../components/shared/ProcessTracker';
import { StatusBadge } from '../../components/shared/StatusBadge';
import { categoryLabel, stageInfo } from '../../utils/caseStatus';
import { fmtDate, fmtDateTime, maskMobile, taka } from '../../utils/bn';
export function FieldCaseView({
  pcr,
  role,
  go
}: {
  pcr: string;
  role: FieldRole;
  go: (s: FieldScreen) => void;
}) {
  const {
    getCase,
    config
  } = useStore();
  const c = getCase(pcr);
  if (!c) return <p className="p-6" data-id="element-1309" data-mp="163lam0zvikfb">কেস পাওয়া যায়নি।</p>;
  const s = stageInfo(c);
  const fieldRole = role === 'wrecker' || role === 'sergeant';
  return <>
      <MobileHeader appName="ডিএমপি যানবাহন হেফাজত" title={c.pcr} onBack={() => go({
      name: 'records'
    })} data-id="element-1310" data-mp="1ytaagb0ukefc" />
      <div className="flex-1 overflow-y-auto no-scrollbar px-4 py-4 space-y-3" data-id="element-1311" data-mp="15qav8y0zh4aj">
        <div className="card overflow-hidden" data-id="element-1312" data-mp="15sexlbj8hv8p">
          <img src={c.photo} alt={`${c.regNo} যানবাহনের ছবি`} className="h-40 w-full object-cover" data-id="element-1313" data-mp="19qkzo694nmna" />
          <div className="p-4" data-id="element-1314" data-mp="vz6hu2qyhrht">
            <div className="flex items-start justify-between gap-2" data-id="element-1315" data-mp="vzzgshjobcpe">
              <div data-id="element-1316" data-mp="10yarsvlpft97">
                <p className="text-base font-bold text-ink" data-id="element-1317" data-mp="10xhqia5ilvyg">{c.regNo}</p>
                <p className="text-xs text-ink-muted" data-id="element-1318" data-mp="m10edgpi4dau">{categoryLabel(c.category, config)} · {c.brand} {c.model} · {c.color}</p>
              </div>
              <StatusBadge label={s.label} tone={s.tone} size="sm" data-id="element-1319" data-mp="qys72cxz03g3" />
            </div>
            <div className="mt-4" data-id="element-1320" data-mp="d382kmiznns7"><ProcessTracker c={c} compact data-id="element-1321" data-mp="i0gjkjsehlrv" /></div>
          </div>
        </div>
        <dl className="card divide-y divide-line text-sm" data-id="element-1322" data-mp="i0q8e41plmvz">
          {[['আটকের কারণ', c.reason], ['আটক স্থান', c.road], ['আটকের সময়', fmtDateTime(c.createdAt)], ['মালিক', `${c.ownerName} · ${c.mobile ? maskMobile(c.mobile) : '—'}`], ['জরিমানা (নমুনা)', taka(c.fine + c.extraCharge)], ['কাগজপত্র জমার শেষ তারিখ', fmtDate(c.deadline)], ['বারকোড', c.barcode.serial ?? 'প্রিন্ট হয়নি'], ['স্টেশন / স্লট', c.station ? `${c.station.station} · ${c.station.slot}` : c.assignedStation], ['গাড়ির অবস্থা', c.station ? `${c.station.condition} — ${c.station.damage}` : '—']].map(([k, v]) => <div key={k} className="flex justify-between gap-3 px-4 py-2" data-id="element-1323" data-mp="2tpwf3ubrk0pv"><dt className="shrink-0 text-ink-muted" data-id="element-1324" data-mp="2ops24ea2do4e">{k}</dt><dd className="text-right font-semibold" data-id="element-1325" data-mp="2or34qarrwptx">{v}</dd></div>)}
        </dl>
        <div className="card p-4" data-id="element-1326" data-mp="2jvxljjpr9p9j">
          <p className="mb-2 text-sm font-bold text-ink" data-id="element-1327" data-mp="2ezfj4qhwe30d">কার্যক্রমের ইতিহাস</p>
          <ol className="space-y-2" data-id="element-1328" data-mp="3ceb8go9jzqtu">
            {[...c.history].reverse().slice(0, 6).map((h, i) => <li key={i} className="border-l-2 border-navy-100 pl-3 text-xs" data-id="element-1329" data-mp="37nuv145qg57h" data-mpi={i}>
                <p className="font-semibold text-ink" data-id="element-1330" data-mp="37lruhq6yetoi">{h.action}</p>
                <p className="text-ink-muted" data-id="element-1331" data-mp="3f0aia90yhxhc">{fmtDateTime(h.at)} · {h.actor}</p>
              </li>)}
          </ol>
        </div>
      </div>
      {fieldRole && c.stage !== 'released' && <div className="shrink-0 border-t border-line bg-white p-3 grid grid-cols-2 gap-2" data-id="element-1332" data-mp="3ovc9daesl9mk">
          <button className="btn btn-outline" onClick={() => go({
        name: 'receipt',
        pcr: c.pcr
      })} data-id="element-1333" data-mp="3twrwr94fzs84">রসিদ</button>
          <button className="btn btn-outline" onClick={() => go({
        name: 'sticker',
        pcr: c.pcr
      })} data-id="element-1334" data-mp="1rxoyzfrhuwj">বারকোড</button>
        </div>}
    </>;
}